import { useState } from 'react';

import { DownOutlined } from '@ant-design/icons';
import { css } from '@emotion/css';
import { Collapse } from 'antd';
import { ColorConstant, Font, FontWeight, Spacing } from 'src/styles';

const { Panel } = Collapse;

export const panelStyle = css`
  ${Spacing.mb32}
  .ant-collapse-header {
    ${Spacing.p0}
  }
  .ant-collapse-header-text {
    ${Font.h3}
    ${FontWeight.normal}
    color: ${ColorConstant.BRAND6};
  }
  .ant-collapse-content {
    ${Spacing.p24}
  }
`;

export const expandIconStyle = css`
  color: ${ColorConstant.BRAND6};
  ${Font.lg}
  ${FontWeight.bold}
`;

interface MCollapseProps {
  activeKey?: string | string[] | number | number[];
  defaultActiveKey?: string | number;
  onChange?: (key: string | string[] | number | number[]) => void;
  optionList?: {
    id: string;
    header?: string;
    content?: React.ReactNode;
  }[];
}

export const MCollapse = ({ defaultActiveKey, optionList, onChange }: MCollapseProps) => {
  const [activeKey, setActiveKey] = useState<string | string[] | number | number[]>(defaultActiveKey || []);

  const _onChange = (key: string | string[] | number | number[]) => {
    setActiveKey(key);

    if (onChange) {
      onChange(key);
    }
  };

  return (
    <Collapse
      activeKey={activeKey}
      defaultActiveKey={defaultActiveKey}
      accordion
      expandIconPosition='end'
      collapsible='header'
      ghost
      expandIcon={({ isActive }) => (
        <span className={expandIconStyle}>
          <span className={Spacing.mr8}> {isActive ? 'Show Less' : 'Show More'}</span>
          <DownOutlined rotate={isActive ? 180 : 0} />
        </span>
      )}
      onChange={_onChange}>
      {optionList?.map(option => (
        <Panel key={option.id} header={option.header} collapsible='header' className={panelStyle}>
          {option.content}
        </Panel>
      ))}
    </Collapse>
  );
};
